import {
    FETCH_MATERIALS_LIST_REQUEST,
    FETCH_MATERIALS_LIST_SUCCESS,
    FETCH_MATERIALS_LIST_FAILURE,
  } from "./FetchMaterialsListTypes";
  
  const initialState = {
    loading: false,
    materialsList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MATERIALS_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_MATERIALS_LIST_SUCCESS:
        return {
          loading: false,
          materialsList: action.payload,
          error: "",
        };
      case FETCH_MATERIALS_LIST_FAILURE:
        return {
          loading: false,
          materialsList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  